import { useSleepingStock } from './ContextAPI';
import FormInfo from './FormInfo';
import PrintIndex from './pdf/PrintIndex';

export default function Index() {
    const { showPdf } = useSleepingStock();

    return showPdf ? <PrintIndex /> : <FormInfo />;
}
